import { useGetQuery } from '../../graphql';
import { GET_WORKSPACE_COMMUNICATION_SETTINGS } from './useWorkspaceEmailSettings';

export interface WorkspacePhoneNumberSettings {
  phoneNumber: string | null;
}

/**
 * Reads the workspace's inbound-call phone number (plan 0025 Phase 2). MUST
 * use the same document as `useWorkspaceEmailSettings` — useGetQuery keys by
 * modelName+id, not by document, so a hook-specific selection silently loses
 * the cache race when both hooks mount on the Communication page.
 */
export const useWorkspacePhoneNumber = (workspaceId?: string) => {
  const { data, isLoading, refetch } = useGetQuery({
    modelName: 'workspace',
    query: GET_WORKSPACE_COMMUNICATION_SETTINGS,
    id: workspaceId ?? '',
    options: {
      enabled: !!workspaceId,
    },
  });

  const workspace = data as WorkspacePhoneNumberSettings | undefined;

  return {
    phoneNumber: workspace?.phoneNumber ?? null,
    isLoading,
    refetch,
  };
};
